import React from 'react';
import UserManagement from './UserManagement';
import CommunityDirectory from '../common/CommunityDirectory';
import { useAuth } from '../../contexts/AuthContext';

const MembersPage = () => {
  const { user } = useAuth();
  const isAdmin = user?.portalRole === 'admin';

  if (!isAdmin) return <CommunityDirectory />;

  return <UserManagement />;
};

export default MembersPage;
